module.exports = __webpack_public_path__ + "static/media/Level_7.6c60ca30.png";